// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__4k5V3","subtitle":"CardContentComponent_subtitle__g622+","map":"CardContentComponent_map__UYIae"};